<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    default() {
      return [];
    },
  },
  modelValue: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

function handleClick(option) {
  emit('update:modelValue', option);
}
</script>

<template>
  <div>
    <button
      v-for="option in props.options"
      :key="option.value"
      :class="['filter-button', { active: option.value === modelValue?.value }]"
      @click="handleClick(option)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<style lang="scss">
.filter-container {
  display: flex;

  @media (max-width: $screen-md) {
    padding: 20px 16px;
  }
}

.filter-button {
  padding: 10px 20px;
  background-color: transparent;
  border-radius: 8px;
  color: #222222;
  cursor: pointer;
  height: 40px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  font-weight: 700;
  border: 2px solid transparent;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: $primary;
  }

  &.active {
    background-color: $grey-text;
    color: $white;
  }
}
</style>
